'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
var focus = require('org/components/focus');

var mobileHeader = $('.mobile-header-container');

var clearSelection = function (element) {
    // ADA Fix, remove tab-index from navigation categories that are not visible
    var tabs;
    if ($(element).parents('.menu-list').length) { // On Sub-Cat
        tabs = $(element).parents('.menu-list').first().find('.dropdown-item:not(.top-category) a');
        $(element).parents('.menu-list').removeAttr('tabindex');
        $(element).closest('.menu-column').find('.dropdown-item .menu-dropdown-link').first()
            .attr('tabindex', 0);
        $(element).parents('.dropdown-menu').find('.menu-link').first()
            .attr('tabindex', 0);
        $(element).parents('.dropdown-menu').find('.back button').attr('tabindex', 0);
        $(element).closest('.menu-column').siblings('.menu-column').each(function () {
            $(this).find('.dropdown-item .menu-dropdown-link').first().attr('tabindex', 0);
            var siblingTabs = $(this).find('.dropdown-item .menu-dropdown-link').first();
            if ($(siblingTabs).parent().nextAll('.dropdown-item').children('.menu-dropdown-link[tabindex]').length > 0) {
                $(siblingTabs).parent().nextAll().children()
                    .attr('tabindex', 0);
            }
        });
    } else { // On Top-level
        tabs = $(element).parents('.dropdown-menu').find('.menu-dropdown-link[tabindex]');
        $(element).closest('.menu-item').find('.menu-link').first()
            .attr('tabindex', 0);
        $(element).closest('.menu-item').siblings().find('.menu-link')
            .attr('tabindex', 0);
    }

    $.each(tabs, function () {
        $(this).attr('tabindex', -1);
    });

    $(element).closest('.dropdown, .dropdown-item').children('.dropdown-menu, .menu-list').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show, .dropdown-item.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show, .dropdown-item.show').children('.menu-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show, .dropdown-item.show').find('.menu-dropdown-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show, .dropdown-item.show').removeClass('show');
    $(element).closest('li').detach();
};

module.exports = function () {
    var isDesktop = function (element) {
        var elementToCheck = element ? $(element).parents('.menu-toggleable-left') : $('.menu-toggleable-left');
        return elementToCheck.css('position') !== 'fixed';
    };

    var setDropdownLinkTabindexes = function () {
        // ADA Fix, make all links tabbable
        if (isDesktop()) {
            $('.menu-dropdown-link[tabindex]').attr('tabindex', 0);
        } else {
            //  ADA Fix, mobile menu screen reader attributes
            $('#sg-navbar-collapse').attr({
                role: 'dialog',
                'aria-modal': 'true',
                'aria-label': 'menu'
            });
            $('.dropdown-menu .menu-dropdown-link[tabindex]').attr('tabindex', -1);
        }
    };

    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('hide');
    });

    var navMenu = document.getElementById('sg-navbar-collapse');
    var hideMobileMenuAfterTransitionEnd = function () {
        if (navMenu.classList.contains('in')) {
            navMenu.addEventListener('transitionend', function () {
                navMenu.classList.add('hide-mobile');
            }, {
                capture: false,
                once: true,
                passive: false
            });
        }
    };

    var ENTERKEYCODE = 13;
    var ESCAPEKEYCODE = 27;

    setDropdownLinkTabindexes();

    var showMobileNavbarSubMenu = function (eventElement) {
        $('.modal-background').show();
        // copy parent element into current UL
        var li = $('<li class="dropdown-item top-category" role="button"></li>');
        var link = eventElement.clone().removeClass('dropdown-toggle')
            .removeAttr('data-toggle')
            .removeAttr('aria-expanded')
            .attr('aria-haspopup', 'false');
        li.append(link);
        var closeMenu = $('<li class="nav-menu"></li>');
        closeMenu.append($('.close-menu').first().clone());
        // Prevent multiple drop-down menus from being created
        var menuList = eventElement.closest('.dropdown-item').find('> .menu-list');
        if (menuList.children('.dropdown-item.top-category').length === 0) {
            if (eventElement.hasClass('has-sub-cat')) {
                menuList
                    .prepend(li)
                    .prepend(closeMenu);
                // copy navigation menu into view
                eventElement.closest('.dropdown-item').addClass('show');
            } else {
                eventElement.parent().children('.dropdown-menu')
                    .prepend(li)
                    .prepend(closeMenu);
                // copy navigation menu into view
                eventElement.parent().addClass('show');
                mobileHeader.css('display', 'none'); // hide mobile header when not on first off-canvas pane
            }
        }

        // ADA The menu-dropdown links with sub-cats only need role=button at mobile, when you can click them to expand another menu level.
        $('h2 a.menu-dropdown-link.has-sub-cat').attr('role', 'button');

        // ADA Fixes
        // Set tab-index for each level so that only the current set of categories can be tabbed into
        var tabs = [];
        if (eventElement.hasClass('dropdown-toggle')) { // Top Level
            // Loop to only get first level
            $.each(eventElement.next().find('.menu-row').children('.menu-column'), function () {
                tabs.push($(this).find('.menu-dropdown-link[tabindex]').first());
                $(this).closest('.dropdown-menu').find('.back').attr('tabindex', 0);
                var siblingTabs = $(this).find('.menu-dropdown-link[tabindex]').first();
                if ($(siblingTabs).parent().nextAll('.dropdown-item').children('.menu-dropdown-link[tabindex]').length > 0) {
                    tabs.push($(siblingTabs).parent().nextAll('.dropdown-item').children('.menu-dropdown-link[tabindex]'));
                }
            });

            // Set focus to back-button
            $('.back, .back button').removeAttr('tabindex');
            eventElement.next().find('.back > button').focus();
        } else { // Sub levels
            tabs = eventElement.parent().next().find('.dropdown-item:not(.top-category) a');

            // Make back button for INACTIVE submenu unreachable with Tab Key
            $('.back, .back button').attr('tabindex', -1);
            // Make back button for ACTIVE submenu reachable with Tab Key, then set focus on it
            eventElement.parent().next().find('.back button').attr('tabindex', 0)
                .focus();
        }

        $('.menu-dropdown-link, .menu-link').attr('tabindex', -1);
        $.each(tabs, function () {
            $(this).attr('tabindex', 0);
        });

        eventElement.attr('aria-expanded', 'true');
        link.attr('tabindex', 0);
    };

    var showNavbarSubmenu = function (eventElement) {
        $('.navbar-nav > li').each(function (index, navElement) {
            if (!$.contains(navElement, eventElement)) {
                $(navElement).find('.show').each(function () {
                    clearSelection(navElement);
                });
                if ($(navElement).hasClass('show')) {
                    $(navElement).removeClass('show');
                    $(navElement).children('ul.dropdown-menu').removeClass('show');
                    $(navElement).children('.nav-link').attr('aria-expanded', 'false');
                }
            }
        });
        // need to close all the dropdowns that are not direct parent of current dropdown
        $(eventElement).parent().addClass('show');
        var dropdownMenu = $(eventElement).siblings('.dropdown-menu');
        dropdownMenu.addClass('show');
        setTimeout(function () {
            if ((dropdownMenu).hasClass('show')) {
                dropdownMenu.addClass('trigger-active');
            }
        }, 150);
        $(eventElement).attr('aria-expanded', 'true');
    };

    var hideNavbarSubmenu = function (eventElement) {
        if (isDesktop(eventElement)) {
            $(eventElement).removeClass('show');
            var dropdownMenu = $(eventElement).children('.dropdown-menu');
            dropdownMenu.removeClass('trigger-active');
            setTimeout(function () {
                dropdownMenu.removeClass('show');
            }, 250);
            $(eventElement).children('.menu-link').attr('aria-expanded', 'false');
            $(eventElement).children('.nav-link').attr('aria-expanded', 'false');
        }
    };

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                } else if (menuItem.prev().length === 0) {
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().parent().children().first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    $('.menu-item.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('click', function (e) {
            setDropdownLinkTabindexes();
            if ($(this).siblings('.dropdown-menu').hasClass('show')) {
                e.preventDefault();
                hideNavbarSubmenu(this.parentElement);
            } else if (isDesktop(this)) {
                if ($(this).hasClass('dropdown-toggle')) {
                    e.preventDefault();
                }
                showNavbarSubmenu(this);
            } else {
                e.preventDefault();
                showMobileNavbarSubMenu($(this));
            }
        })
        .on('keydown', function (e) {
            var isEnterPressed = (e.key === 'Enter' || e.keyCode === ENTERKEYCODE);

            if (!isEnterPressed || this !== document.activeElement) {
                return;
            }

            setDropdownLinkTabindexes();
            if ($(this).siblings('.dropdown-menu').hasClass('show')) {
                e.preventDefault();
                hideNavbarSubmenu(this.parentElement);
            } else if (isDesktop(this)) {
                if ($(this).hasClass('dropdown-toggle')) {
                    e.preventDefault();
                }
                showNavbarSubmenu(this);
            } else {
                e.preventDefault();
                showMobileNavbarSubMenu($(this));
            }
        });

    $('body').on('keydown', function (e) {
        var isEscapePressed = (e.key === 'Escape' || e.keyCode === ESCAPEKEYCODE);

        if (isEscapePressed && $('.dropdown-menu.show.trigger-active').length > 0) {
            e.preventDefault();
            hideNavbarSubmenu($('.dropdown-menu.show.trigger-active').parent().get(0));
        }
    })
        .on('click', function (e) {
            var container = $('.dropdown-menu.show.trigger-active').parent();

            // if the target of the click isn't inside the open submenu, close it
            if (container.length > 0 && !container.is(e.target) && container.has(e.target).length === 0) {
                e.preventDefault();
                e.stopPropagation();
                hideNavbarSubmenu(container.get(0));
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        hideMobileMenuAfterTransitionEnd();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();
        $('.navbar-toggler').focus();
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        if (!isDesktop(this)) {
            e.preventDefault();
            clearSelection(this);

            if ($('.top-category').length) { // show/hide mobile header for devices with short heights
                mobileHeader.css('display', 'none');
            } else {
                mobileHeader.css('display', 'block');
            }

            // set focus on parent category
            const $mainMenu = $('.menu-item.dropdown').first();
            focus.focusElement(0, $mainMenu);
        }
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        hideMobileMenuAfterTransitionEnd();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();
        $('.navbar-toggler').focus();
    });

    $('.navbar-toggler').on('click', function (e) {
        e.preventDefault();
        setDropdownLinkTabindexes();
        const $mainMenu = $('.main-menu');
        $mainMenu.toggleClass('hide-mobile');

        // Timeout needed for css transition to apply properly.
        setTimeout(function () {
            $mainMenu.toggleClass('in');
            if ($mainMenu.hasClass('in')) {
                $mainMenu.find('.close-button button').focus();
                $('.modal-background').show();
                focus.trapModalFocus('.main-menu');
                focus.focusElement(0, $mainMenu);
                // Need to make sure the visible menu elements are tabbable, as setDropdownLinkTabindexes() just marked them all not-tabbable.
                if ($('.dropdown-item.show').length) {
                    $('.dropdown-item.show .menu-dropdown-link[tabindex]', $mainMenu).attr('tabindex', 0);
                } else {
                    $('.menu-item.show div.menu-list>.dropdown-item>h2>a.menu-dropdown-link[tabindex]', $mainMenu).attr('tabindex', 0);
                    $('.menu-item.show div.menu-list>.dropdown-item>a.menu-dropdown-link[tabindex]', $mainMenu).attr('tabindex', 0);
                }
            } else {
                $('.modal-background').hide();
                $('.navbar-toggler').focus();
            }
        }, 20);
    });

    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.children('a').first().next().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            32: function ($popover) { // space
                $popover.toggleClass('show');
                $('.navbar-header .user').toggleClass('popover-visible');
            },
            27: function ($popover) { // escape
                $(this).focus();
                $popover.removeClass('show');
            },
            13: function ($popover) { // enter
                $popover.toggleClass('show');
            },
            9: function ($popover) { // tab
                $popover.children('a').first().focus();
                $('.minicart-link, .reset-button').on('focus', function () {
                    $popover.removeClass('show');
                    $('.navbar-header .user').removeClass('popover-visible');
                    $('#myaccount').attr('aria-expanded', false);
                });
                return;
            }
        },
        function () {
            var $popover = $('.user .popover');
            if (!($popover.hasClass('show')) && $('.navbar-header .user').hasClass('popover-visible')) {
                $('#myaccount').attr('aria-expanded', true);
            } else if (($popover.hasClass('show')) && !$('.navbar-header .user').hasClass('popover-visible')) {
                $('#myaccount').attr('aria-expanded', false);
            }
            return $popover;
        }
    );

    $('.navbar-header .user').on('click', function () {
        $(this).toggleClass('popover-visible');
        if ($(this).hasClass('popover-visible')) {
            $('.navbar-header .user .popover').addClass('show');
            $('#myaccount').attr('aria-expanded', true);
            $('#myaccount-popover').attr('tabindex', '0');
            $('#myaccount-popover').focus();
        } else {
            $('.navbar-header .user .popover').removeClass('show');
            $('#myaccount').attr('aria-expanded', false);
            $('#myaccount-popover').removeAttr('tabindex');
        }
    });

    $('.navbar-header .user').on('mouseenter', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('#myaccount').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        if (!$(this).hasClass('popover-visible')) {
            $('.navbar-header .user .popover').removeClass('show');
            $('#myaccount').attr('aria-expanded', 'false');
        }
    });
};
